import React, { useState } from "react";
import { NavLink, useLocation }  from "react-router-dom";
import './navbar.css';
import Logo from './../assets/shared/logo.svg';
import menuOpen from './../assets/shared/icon-hamburger.svg';
import menuClose from './../assets/shared/icon-close.svg';

const Navbar = () => {
    const [isMenuOpen, setMenuOpen] = useState(false);
    const toggleMenu = () => {
        setMenuOpen(!isMenuOpen);
    };
    const location = useLocation();
    return (
        <>
            <nav className="navbar">
                <NavLink className="navbar-brand" to="/">
                    <img className="navbar-logo" src={Logo} alt="Space Travel"/>
                </NavLink>
                <ul className={(isMenuOpen) ? 'navbar-menu show' : 'navbar-menu'}>
                    <li className={`navbar-item${location.pathname === '/' ? ' active' : ''}`}>
                        <NavLink className="navbar-link" to="/"><strong aria-hidden="true">00</strong>Home</NavLink>
                    </li>
                    <li className={`navbar-item${location.pathname === '/destination' ? ' active' : ''}`}>
                        <NavLink className="navbar-link" to="/destination"><strong aria-hidden="true">01</strong>Destination</NavLink>
                    </li>
                    <li className={`navbar-item${location.pathname === '/crew' ? ' active' : ''}`}>
                        <NavLink className="navbar-link" to="/crew"><strong aria-hidden="true">02</strong>Crew</NavLink>
                    </li>
                    <li className={`navbar-item${location.pathname === '/technology' ? ' active' : ''}`}>
                        <NavLink className="navbar-link" to="/technology"><strong aria-hidden="true">03</strong>Technology</NavLink>
                    </li>
                </ul>
                <button className="navbar-toggle" onClick={toggleMenu}>
                    <img src={(!isMenuOpen) ? menuOpen : menuClose} alt="Menu Button" className="navbar-toggle-icon" />
                </button>
            </nav>
        </>
    ); 
};

export default Navbar;